import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "@shared-ui/viewport-context";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import ViewWhereToStayGuideButton from "./components/ViewWhereToStayGuideButton";
import { NeighborhoodCard } from "./components/NeighborhoodCard";
import { DestinationNeighborhoodsProps } from "./typings";
import { Neighborhood, TeNeighborhoodFlexModuleResult } from "typings/microserviceModels/te-neighborhood-flex-module";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "uitk-react-text";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { withStores } from "stores";
import { observer } from "mobx-react";
import { getFmId } from "src/stores/ExperienceTemplateStore";
import { UitkSpacing } from "uitk-react-spacing";

const DestinationNeighborhoods = withStores(
  "context",
  "flexModuleModelStore"
)(
  observer((props: DestinationNeighborhoodsProps) => {
    const { templateComponent, flexModuleModelStore, context } = props;

    if (!templateComponent) {
      return null;
    }
    const {
      metadata: { id },
      config: { fmTitleId },
    } = templateComponent;
    const fmId = getFmId(templateComponent);
    const model = flexModuleModelStore.getModel(id) as TeNeighborhoodFlexModuleResult | null;

    if (!model) {
      return null;
    }

    const { content } = model;
    const { formatText } = useLocalization();

    if (!content?.items?.length) {
      return null;
    }

    const { items, whereToStayUrl } = content;
    const neighborhoods = items.slice(0, 6);

    const neighborhoodsKeyHelper: ItemKeyHelper = new ItemKeyHelper("popular-neighborhood");

    const neighborhoodCards = (isDesktop: boolean) =>
      neighborhoods.map((neighborhood: Neighborhood, neighborhoodIndex: number) => (
        <UitkLayoutGridItem key={neighborhoodsKeyHelper.next()}>
          <UitkSpacing margin={{ blockend: "three" }}>
            <NeighborhoodCard
              neighborhood={neighborhood}
              position={neighborhoodIndex + 1}
              context={context}
              isDesktop={isDesktop}
              showFavorite
              isClickable
              view={model.view}
            />
          </UitkSpacing>
        </UitkLayoutGridItem>
      ));

    let titleText = "";

    if (content.title) {
      titleText = content.title;
    } else if (context.searchContext.location.type === "neighborhood") {
      titleText = formatText("destinationNeighborhood.neighborhood.title", context.searchContext.location.parent.name);
    } else {
      titleText = formatText("destinationNeighborhood.title", context.searchContext.location.name);
    }

    return (
      <UitkSpacing padding={{ block: "six" }}>
        <div className="DestinationNeighborhoods" id={id} data-fm={fmId} data-fm-title-id={fmTitleId}>
          <UitkHeading tag="h3" size={4}>
            {titleText}
          </UitkHeading>

          <Viewport>
            <ViewSmall>
              <UitkSpacing margin={{ blockstart: "four" }}>
                <UitkLayoutGrid columns={1} space="one" className="destinationNeighborhoodsContainer">
                  {neighborhoodCards(false)}
                </UitkLayoutGrid>
              </UitkSpacing>
            </ViewSmall>

            <ViewLarge>
              <UitkSpacing margin={{ blockstart: "four" }}>
                <UitkLayoutGrid columns={3} space="three" className="destinationNeighborhoodsContainer">
                  {neighborhoodCards(true)}
                </UitkLayoutGrid>
              </UitkSpacing>
            </ViewLarge>
          </Viewport>

          {Boolean(whereToStayUrl) && <ViewWhereToStayGuideButton href={whereToStayUrl} />}
        </div>
      </UitkSpacing>
    );
  })
);

export default DestinationNeighborhoods;
